<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title class="grey1">{{data.sysText.caseLeaveInfoDialog.editLeaveInformation | titlecase}}</h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close()" [attr.aria-label]="!isAnonymous ? data.sysText.caseLeaveInfoDialog.cancel : data.sysText.caseLeaveInfoDialog.close" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

@if (!isAnonymous) {
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="main-container">
        <div class="column-container">
          <!-- CaseID -->
          <app-input-field
            [control]="caseId"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_caseNum"
            [inputType]="'string'"
            [icon]="'assignment_turned_in'"
            [hint]="(data.fieldNotifications.hasOwnProperty('caseId') ? data.fieldNotifications['caseId'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-input-field>
          <!-- daterecieved -->
          <app-date-field
            [control]="dateReceived"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_dateReceived"
            [icon]="'calendar_today'"
            [hint]="(data.fieldNotifications.hasOwnProperty('dateReceived') ? data.fieldNotifications['dateReceived'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-date-field>
          <!-- stage  -->
          <app-input-field
            [control]="stage"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_stage"
            [icon]="'format_list_numbered'"
            [hint]="(data.fieldNotifications.hasOwnProperty('stage') ? data.fieldNotifications['stage'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-input-field>
          <!-- req start date  -->
          <app-date-field
            [control]="requestedStartDate"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_requestedStartDate"
            [icon]="'calendar_today'"
            [hint]="(data.fieldNotifications.hasOwnProperty('requestedStartDate') ? data.fieldNotifications['requestedStartDate'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-date-field>
          <!-- req end date  -->
          <app-date-field
            [control]="requestedEndDate"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_requestedEndDate"
            [hint]="(data.fieldNotifications.hasOwnProperty('requestedEndDate') ? data.fieldNotifications['requestedEndDate'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-date-field>
          <!-- start date -->
          <app-date-field
            [control]="startDate"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_startDate"
            [icon]="'calendar_today'"
            [hint]="(data.fieldNotifications.hasOwnProperty('startDate') ? data.fieldNotifications['startDate'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-date-field>
          <!-- end date -->
          <app-date-field
            [control]="endDate"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_endDate"
            [hint]="(data.fieldNotifications.hasOwnProperty('endDate') ? data.fieldNotifications['endDate'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-date-field>
          <!-- leave reason  -->
          <app-select-field
            [control]="leaveReason"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_leaveReason"
            [options]="data.options.leaveReasons"
            [icon]="'live_help'"
            [shouldCapitalize]="false"
            [showBlankOption]="true"
            [hint]="(data.fieldNotifications.hasOwnProperty('leaveReason') ? data.fieldNotifications['leaveReason'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-select-field>
          <!-- leave type  -->
          <app-select-field
            [control]="leaveType"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_leaveType"
            [options]="data.options.leaveTypes"
            [icon]="'domain'"
            [shouldCapitalize]="false"
            [showBlankOption]="true"
            [hint]="(data.fieldNotifications.hasOwnProperty('leaveType') ? data.fieldNotifications['leaveType'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-select-field>
          <!-- leave subtype -->
          <app-autocomplete-field
            [control]="form.controls.leaveSubtype"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_leaveSubtype"
            [options]="data.options.leaveSubtypes"
            [isSimple]="true"
            [hint]="(data.fieldNotifications.hasOwnProperty('leaveSubtype') ? data.fieldNotifications['leaveSubtype'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-autocomplete-field>
          <!-- leave category  -->
          <app-input-field
            [control]="leaveCategory"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_leaveCategory"
            [inputType]="'string'"
            [icon]="'business_center'"
            [hint]="(categoryHint != null ? categoryHint : data.fieldNotifications.hasOwnProperty('leaveCategory') ? data.fieldNotifications['leaveCategory'] : null) | capitalizefirst"
            [isHintHighlighted]="categoryHint != null"
            [isHintWarning]="categoryHint == null">
          </app-input-field>
          <!-- intermittent freq  -->
          <app-text-area
            [control]="intermittentFreq"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_intermittentFreq"
            [icon]="'calendar_today'"
            [hint]="(intermittentFreqHint != null ? intermittentFreqHint : data.fieldNotifications.hasOwnProperty('intermittentFreq') ? data.fieldNotifications['intermittentFreq'] : null) | capitalizefirst"
            [isHintHighlighted]="intermittentFreqHint != null"
            [isHintWarning]="intermittentFreqHint == null">
          </app-text-area>`
          <!-- import verified -->
          @if (data.caseData.leaveInformation.caseImportInfo) {
            <div class="check-field">
              <div class="check-container">
                <mat-icon>task</mat-icon>
                <div class="check-label-container">
                  <mat-checkbox
                    [formControl]="importVerified"
                    [aria-label]="data.sysText.caseLeaveInfo.caseLeaveInfo_importVerified">
                  </mat-checkbox>
                  <mat-label>
                    {{ data.sysText.caseLeaveInfo.caseLeaveInfo_importVerified}}
                  </mat-label>
                </div>
              </div>
              <mat-hint>
                {{data.sysText.caseLeaveInfo.caseLeaveInfo_importOn + " " + (data.caseData.leaveInformation.caseImportInfo.importDateTime | date: 'MMM d, y h:mm a')}}
              </mat-hint>
            </div>
          }
        </div>
        <div class="column-container">
          <!-- twelveMonthsHours -->
          <app-input-field
            [control]="twelveMonthsHours"
            [label]="data.sysText.caseLeaveInfo.twelveMonthsHours"
            [removeLabelCasePipe]="true"
            [inputType]="'number'"
            [icon]="'functions'"
            [hint]="(data.fieldNotifications.hasOwnProperty('twelveMonthsHours') ? data.fieldNotifications['twelveMonthsHours'] : null)"
            [isHintHighlighted]="false"
            [isHintWarning]="true"
            [info]="data.sysText.caseLeaveInfo.twelveMonthsHours_info">
          </app-input-field>
          <!-- twelveMonthsDate -->
          <app-date-field
            [control]="twelveMonthsDate"
            [label]="data.sysText.caseLeaveInfo.twelveMonthsDate"
            [hint]="(data.fieldNotifications.hasOwnProperty('twelveMonthsDate') ? data.fieldNotifications['twelveMonthsDate'] : null)"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-date-field>
          <!-- twelveMonthsComments -->
          <app-text-area
            [control]="twelveMonthsComments"
            [label]="data.sysText.caseLeaveInfo.twelveMonthsComments"
            [shouldCapitalizeLabel]="false"
            [hint]="(data.fieldNotifications.hasOwnProperty('twelveMonthsComments') ? data.fieldNotifications['twelveMonthsComments'] : null)"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-text-area>
          <!-- averageWeeklyHours -->
          <app-input-field
            [control]="averageWeeklyHours"
            [label]="data.sysText.caseLeaveInfo.averageWeeklyHours"
            [removeLabelCasePipe]="true"
            [inputType]="'number'"
            [icon]="'functions'"
            [hint]="(data.fieldNotifications.hasOwnProperty('averageWeeklyHours') ? data.fieldNotifications['averageWeeklyHours'] : null)"
            [isHintHighlighted]="false"
            [isHintWarning]="true"
            [info]="data.sysText.caseLeaveInfo.averageWeeklyHours_info">
          </app-input-field>
          <!-- averageWeeklyHoursDate -->
          <app-date-field
            [control]="averageWeeklyHoursDate"
            [label]="data.sysText.caseLeaveInfo.averageWeeklyHoursDate"
            [hint]="(data.fieldNotifications.hasOwnProperty('averageWeeklyHoursDate') ? data.fieldNotifications['averageWeeklyHoursDate'] : null)"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-date-field>
          <!-- averageWeeklyHoursComments -->
          <app-text-area
            [control]="averageWeeklyHoursComments"
            [label]="data.sysText.caseLeaveInfo.averageWeeklyHoursComments"
            [shouldCapitalizeLabel]="false"
            [hint]="(data.fieldNotifications.hasOwnProperty('averageWeeklyHoursComments') ? data.fieldNotifications['averageWeeklyHoursComments'] : null)"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-text-area>
          <!-- averageWeeklyWorkdays -->
          <app-input-field
            [control]="averageWeeklyWorkdays"
            [label]="data.sysText.caseLeaveInfo.averageWeeklyWorkdays"
            [removeLabelCasePipe]="true"
            [inputType]="'number'"
            [icon]="'functions'"
            [hint]="(data.fieldNotifications.hasOwnProperty('averageWeeklyWorkdays') ? data.fieldNotifications['averageWeeklyWorkdays'] : null)"
            [isHintHighlighted]="false"
            [isHintWarning]="true"
            [info]="data.sysText.caseLeaveInfo.averageWeeklyWorkdays_info">
          </app-input-field>
          <!-- averageWeeklyWorkdaysDate -->
          <app-date-field
            [control]="averageWeeklyWorkdaysDate"
            [label]="data.sysText.caseLeaveInfo.averageWeeklyWorkdaysDate"
            [hint]="(data.fieldNotifications.hasOwnProperty('averageWeeklyWorkdaysDate') ? data.fieldNotifications['averageWeeklyWorkdaysDate'] : null)"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-date-field>
          <!-- averageWeeklyWorkdaysComments -->
          <app-text-area
            [control]="averageWeeklyWorkdaysComments"
            [label]="data.sysText.caseLeaveInfo.averageWeeklyWorkdaysComments"
            [shouldCapitalizeLabel]="false"
            [hint]="(data.fieldNotifications.hasOwnProperty('averageWeeklyWorkdaysComments') ? data.fieldNotifications['averageWeeklyWorkdaysComments'] : null)"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-text-area>
          <!-- eligibility  -->
          <app-select-field
            [control]="eligibility"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_eligibility"
            [options]="data.options.eligibility"
            [icon]="'domain'"
            [shouldCapitalize]="false"
            [showBlankOption]="true"
            [hint]="(data.fieldNotifications.hasOwnProperty('eligibility') ? data.fieldNotifications['eligibility'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-select-field>
          <!-- ineligibility reason  -->
          <app-select-field
            [control]="ineligibilityReasonId"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_ineligibilityReason"
            [options]="data.options.ineligibilityReasons"
            [shouldCapitalize]="false"
            [showBlankOption]="true"
            [hint]="(data.fieldNotifications.hasOwnProperty('ineligibilityReason') ? data.fieldNotifications['ineligibilityReason'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-select-field>
          <!-- ineligibility reason comments  -->
          <app-text-area
            [control]="ineligibilityReasonComments"
            [label]="data.sysText.caseLeaveInfo.caseLeaveInfo_ineligibilityReasonComments"
            [hint]="(data.fieldNotifications.hasOwnProperty('ineligibilityReasonComments') ? data.fieldNotifications['ineligibilityReasonComments'] : null) | capitalizefirst"
            [isHintHighlighted]="false"
            [isHintWarning]="true">
          </app-text-area>
          <!-- related case  -->
          <div class="select-container">
            <mat-icon [ngClass]="{ focus: select.focused }">assignment_turned_in</mat-icon>
            <mat-form-field color="accent">
              <mat-label>{{ data.sysText.caseLeaveInfo.caseLeaveInfo_relatedCases | titlecase }}</mat-label>
              <mat-select #select="matSelect" [formControl]="relatedCases" multiple disableOptionCentering panelClass="dropDownSelectMultiple" panelWidth="fit-content">
                <mat-select-trigger>
                  @if (relatedCases.value?.length >= 1) {
                    <span>
                      @for (relCase of relatedCases.value; track relCase; let i = $index) {
                        <span>
                          {{relCase}}@if (i !== relatedCases.value?.length - 1) {
                          <span>, </span>
                        }
                      </span>
                    }
                  </span>
                }
              </mat-select-trigger>
              @for (case of data.options.relatedCases; track case) {
                <mat-option [value]="case.caseId">
                  <span>{{ case.caseId }}</span>
                  @if (case.leaveType) {
                    <span class="caption option-extras">{{ case.leaveType }}</span>
                  }
                  @if (case.startDate) {
                    <span class="caption option-extras">@if (case.leaveType) {
                      <span class="bullet-spacing">&bull;</span>
                    }{{ data.sysText.caseLeaveInfo.caseLeaveInfo_started | titlecase }} {{case.startDate | date}}</span>
                  }
                </mat-option>
              }
            </mat-select>
            @if (data.fieldNotifications.hasOwnProperty('relatedCases')) {
              <mat-hint class="warn">
                {{ data.fieldNotifications['relatedCases'] }}
              </mat-hint>
            } @else if (data.options.relatedCases.length === 0) {
              <mat-hint>{{ data.sysText.caseLeaveInfo.caseLeaveInfo_noRelatedCases }}</mat-hint>
            }
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>
} @else {
  <mat-dialog-content class="form-container">
    <p class="disallow">{{ data.sysText.caseLeaveInfoDialog.caseLeaveInfo_anonymousMessage }}</p>
  </mat-dialog-content>
}


<mat-dialog-actions align="end">
  @let isSubmitting = isSubmitting$ | async;
  @if (this.form.errors?.msError) {
    <mat-error class="mse-form-error caption">{{ $safeNavigationMigration(this.form.errors?.msError) | replaceBankNames: data.caseData.leaveHoursBanksBuckets}}</mat-error>
  }
  @if (!(isMobile$ | async)) {
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      (click)="close()">
      {{ !isAnonymous ? data.sysText.caseLeaveInfoDialog.cancel : data.sysText.caseLeaveInfoDialog.close }}
    </button>
  }
  @if (!isAnonymous) {
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.caseLeaveInfoDialog.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit()">
      {{ data.sysText.caseLeaveInfoDialog.save }}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  }
</mat-dialog-actions>